import * as React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import TextCellWrapper from '../TextCellWrapper/TextCellWrapper';
var DEFAULT_DATE_FORMAT = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};
export default function DateCell(_ref) {
  var value = _ref.value,
    _ref$column = _ref.column,
    column = _ref$column === void 0 ? {} : _ref$column;
  var format = column.dateFormat || DEFAULT_DATE_FORMAT;
  return /*#__PURE__*/React.createElement(TextCellWrapper, null, value ? /*#__PURE__*/React.createElement(FormattedDate, Object.assign({
    value: value
  }, format)) : column.fallbackI18nKey ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: column.fallbackI18nKey
  }) : '');
}